export default __webpack_public_path__ + "static/media/14.56b0827f.svg";